import React, { useContext, useEffect, useRef, useState } from "react";
import { backIncstance, detectUserAgent, formatToKoreanWon } from "../../utils/commonFunctions";
import { MyContext } from "../../context/MyContext";
import { useNavigate } from "react-router-dom";

/**
 * 결제 오픈시 필요한 소스
 */
const URLS = {
  GET_LIST: process.env.REACT_APP_PRODUCT_LIST,
  // GET_LIST: process.env.REACT_APP_MORE_PRODUCT_LIST,
  REQUEST_ORDER: process.env.REACT_APP_MYPAGE_GENERATE_ORDER_LIST,
  CHECK_ORDER: process.env.REACT_APP_MYPAGE_ORDER_CHECK,
  CHECK_USER: process.env.REACT_APP_VERIFY_USER,
  VERIFY_LINK: process.env.REACT_APP_DONGA_VARIFY
}
const TITLE = `과학의 호기심부터 탐구력까지,\n 모든 것을 한번에 해결하고 관리하세요! 🤓`
const COLORS = ['rgba(98, 35, 255, 1)', 'rgba(34, 91, 239, 1)', 'rgba(68, 120, 255, 1)', 'rgba(12, 167, 255, 1)']
const BENEFITS = [
  {
    NAME: "‍🎓 튜터 질문 1,000개",
    DETAIL: "(30일 기준)",
  },
  {
    NAME: "📝 소크라테스 면접 50회",
    DETAIL: `(30일 기준)`,
  },
  {
    NAME: "📊 활동 분석 리포트 제공",
    DETAIL: "",
  },
  {
    NAME: "‍📚 d라이브러리 무제한 이용",
    DETAIL: "(월 5,900원)",
  },
]
// 기본 요금제
const DEFAULT = [
  {
    item_id: null,
    name: "d라이브러리 All 패스 1개월",
    discount_price: null,
    price: 17900,
    discount_ratio: null
  },
  {
    item_id: null,
    name: "d라이브러리 All 패스 6개월",
    discount_price: 89500,
    price: 107400,
    discount_ratio: 0.17
  },
  {
    item_id: null,
    name: "d라이브러리 All 패스 1년",
    discount_price: 161000,
    price: 214800,
    discount_ratio: 0.25
  },
  {
    item_id: null,
    name: "d라이브러리 All 패스 1년 (교사전용)",
    discount_price: 144900,
    price: 214800,
    discount_ratio: 0.32
  },
  {
    item_id: null,
    name: "d라이브러리 Basic 패스 1개월",
    discount_price: null,
    price: 5900,
    discount_ratio: null
  },
  {
    item_id: null,
    name: "d라이브러리 Basic 패스 6개월",
    discount_price: 29500,
    price: 35400,
    discount_ratio: 0.17
  },
  {
    item_id: null,
    name: "d라이브러리 Basic 패스 1년",
    discount_price: 53000,
    price: 70800,
    discount_ratio: 0.25
  },
  {
    item_id: null,
    name: "d라이브러리 Basic 패스 1년 (교사전용)",
    discount_price: 47700,
    price: 70800,
    discount_ratio: 0.32
  },

]


/**
 * 결제 요청 순서
 * 1. 본인 인증 확인
 * 2. 주문 생성
 * 3. 주문 생성 확인
 * 4. 응답으로 payUrl 연결
 */

const POLLING_INTERVAL = 1000; // 1초 간격으로 폴링
const POLLING_DURATION = 60000; // 60초 동안 폴링

const Test = props => {

  const userInfo = localStorage.getItem('userInfo')
  const { setAlertSetting, setAlertModal, clearState, user, isMobile } = useContext(MyContext)
  const navigation = useNavigate()



  const [productList, setProductList] = useState([...DEFAULT])
  const [selectedItem, setSelectedItem] = useState({
    item_id: null,
    name: null,
    price: 0,
    discount_price: 0,
    discount_ratio: 0,
  })
  const [isAgree, setIsAgree] = useState(false) // 환불규정 동의 유무
  /**
 *
 * @param {target url} target
 * @param {response data} response
 */
  const handleError = (target, response) => {
    const code = response.code;
    const isVerify = target.includes(URLS.CHECK_USER);

    const text =
      (code === 401 && isVerify) ? '본인 인증 후 구매 가능힙니다.\n 회원정보수정에서 본인인증을 진행해주세요.'
        : (code === 401 && !isVerify) ? '로그인이 필요합니다.\n'
          : code === 409 ? '동일한 상품에 대한 구매내역이 있습니다.\n 구매내역으로 이동하시겠습니까?'
            : code === 408 ? '결제 시간이 초과되었습니다.\n 다시 시도해주세요.'
              : '결제에 실패했습니다.\n 다시 시도해주세요.';

    const confirmText =
      (code === 401 && isVerify) ? '인증하러 가기'
        : (code === 409 || (code === 401 && !isVerify)) ? '이동하기'
          : '닫기';

    setAlertSetting(prev => {
      const newAlertSetting = {
        ...prev,
        alertTxt: text,
        double: (code === 401 || code === 409) ? true : false,
        btnTxt: confirmText,
      };

      if (code !== 404) {
        newAlertSetting.onConfirm = () => {
          clearState();
          if (code === 401) {
            if (isVerify) {
              window.open(`${URLS.VERIFY_LINK}/member/info`);
            } else {
              navigation('/login', { state: { from_chat: null, his_cnt: 0, is_writed: false, is_completed: false } });
            }
            return
          } else if (code === 409) {
            navigation('/settings/order-list');
            return
          }
        };
      }

      return newAlertSetting;
    });
  };

  const touchAPI = async (method, url, data) => {

    try {
      const response = await backIncstance(method, url, data)
      if (response.status !== 200) {
        if (user.id) {
          handleError(url, response)
        }
        return
      }
      return response
    } catch (err) {
      setAlertSetting(prev => ({
        ...prev,
        alertTxt: `서버 오류입니다.\n관리자에게 문의 바랍니다.`,
        btnTxt: '닫기'
      }));
    } finally {

    }

  }
  const [fetching, setFetching] = useState(false);
  /**
   * 주문 완료 후 polling 중단
   * 서비스 닫고 결제창만 켜있을경ㄹ우 /check 가 안되어서 backend 추가되면
   * @param {} method
   * @param {*} url
   * @param {*} data
   * @returns
   */

  const pollingAPI = async (method, url, data, paymentWindow) => {

    const startTime = Date.now();
    let isPolling = true;

    const poll = async () => {
      if (!isPolling || (paymentWindow && paymentWindow.closed)) {
        isPolling = false;
        setFetching(false);
        paymentRef.current = false
        return; // 결제 창이 닫혔거나 폴링 중단 조건이 만족되면 종료
      }
      try {
        const response = await backIncstance(method, url, data);

        // 408 에러 발생 시 폴링 계속 진행
        if (response.status === 408) {
          if ((Date.now() - startTime) < POLLING_DURATION) {
            setTimeout(poll, POLLING_INTERVAL);
          } else {
            setAlertSetting(prev => ({
              ...prev,
              alertTxt: `결제 시간이 초과되었습니다.\n다시 시도해주세요.`,
              btnTxt: '닫기'
            }));
            isPolling = false;
          }
          return;
        }

        if (response.status !== 200 && !url.includes(URLS.REQUEST_ORDER)) {
          handleError(url, response);
          paymentRef.current = false
          isPolling = false;
          return;
        }

        const responseData = await response.json();

        if (!responseData.detail) {
          isPolling = false;
          if (paymentWindow) {
            paymentWindow.close();
            paymentRef.current = false
          }
          setAlertSetting(prev => ({
            ...prev,
            alertTxt: `결제가 완료되었습니다.\n 구매내역 페이지로 이동하겠습니까?`,
            double: true,
            btnTxt: '이동하기',
            onConfirm: () => {
              if (typeof prev.onConfirm === 'function') {
                prev.onConfirm();
              }
              navigation('/settings/order-list');
            }
          }));
          return responseData;
        } else {
          if ((Date.now() - startTime) < POLLING_DURATION) {
            setTimeout(poll, POLLING_INTERVAL);
          } else {
            paymentRef.current = false
            setAlertSetting(prev => ({
              ...prev,
              alertTxt: `결제가 완료되지 않았습니다.\n다시 시도해주세요.`,
              btnTxt: '닫기'
            }));
            isPolling = false;
          }
          return responseData;
        }

      } catch (err) {
        setAlertSetting(prev => ({
          ...prev,
          alertTxt: `서버 오류입니다.\n관리자에게 문의 바랍니다.`,
          btnTxt: '닫기'
        }));
      } finally {
        setFetching(false);

      }
    };

    return poll();
  };

  const paymentRef = useRef(false)


  const handlePurchase = async (e, item) => {

    e.stopPropagation();


    setSelectedItem(item)
    /** 규정 미 동의시 진행 불가 */
    // if (!isAgree) {
    //   setAlertSetting(prev => ({
    //     ...prev,
    //     alertTxt: '상품 구매 규정 동의 체크 후 진행해주세요.'
    //   }))
    //   return
    // }
    /** 본인 인증 여부 체크, 미이행시 진행 불가 */

    const response = await touchAPI('GET', URLS.CHECK_USER)
    if (response === undefined) {
      const isLogin = user.id ? true : false;
      setAlertSetting(prev => ({
        ...prev,
        alertTxt: isLogin ? `본인 인증이 필요합니다.\n 본인 인증 하러가기` : `로그인이이 필요합니다.\n 로그인 하러가기`,
        double: true,
        btnTxt: isLogin ? '인증하러 가기' : '이동하기',
        onConfirm: () => {
          if (typeof prev.onConfirm === 'function') {
            prev.onConfirm();
          }
          if (isLogin) {
            window.open(`${URLS.VERIFY_LINK}/member/info`);
          } else {
            navigation('/login', { state: { from_chat: null, is_writed: false, is_completed: false, his_cnt: 0 } })
          }
        }
      }));
      return
    } else if (response) {
      const resData = await response.json();
      const device = detectUserAgent();
      const reqData = {
        item_id: item.item_id,
        order_env: device,
        order_agree: isAgree
      }
      if (resData.code === 200) {
        /** 결제 요청 API */
        const orderRes = await touchAPI('POST', URLS.REQUEST_ORDER, reqData)
        // if (orderRes && orderRes.status === 200) {
        if (orderRes.status === 200) {
          window.open(item.url)
          const orderResData = await orderRes.json();
          if (orderResData.pay_url) {
            // 요청 부분
            // if (paymentWindow) {
            //   const checkReq = `?order_no=${orderResData.order_no}`;
            //   paymentRef.current = true
            //   const checkRes = await pollingAPI('GET', URLS.CHECK_ORDER, checkReq, paymentWindow);
            //   // if (checkRes && checkRes.code === 200) {
            //   //   if (paymentWindow) {
            //   //     paymentWindow.close();
            //   //   }
            //   //   setAlertSetting(prev => ({
            //   //     ...prev,
            //   //     alertTxt: `결제가 완료되었습니다.\n 구매내역 페이지로 이동하겠습니까?`,
            //   //     double: true,
            //   //     btnTxt: '이동하기',
            //   //     onConfirm: () => {
            //   //       if (typeof prev.onConfirm === 'function') {
            //   //         prev.onConfirm();
            //   //       }
            //   //       navigation('/settings/order-list');
            //   //     }
            //   //   }));
            //   // } else if (checkRes && checkRes.code === 408 && !fetching) {
            //   //   paymentWindow.close()
            //   //   setAlertSetting(prev => ({
            //   //     ...prev,
            //   //     alertTxt: `결제에 실패하였습니다.\n 다시 시도해주세요.`,
            //   //     btnTxt: '닫기',
            //   //   }));
            //   // }
            // } else {
            //   paymentRef.current = false
            // }
          }
        }

      } else if (resData.code === 401) {
        setAlertSetting(prev => ({
          ...prev,
          alertTxt: `본인 인증이 필요합니다.\n 본인 인증 하러가기`,
          double: true,
          btnTxt: '인증하러 가기',
          onConfirm: () => {
            if (typeof prev.onConfirm === 'function') {
              prev.onConfirm();
            }
            window.open(`${URLS.VERIFY_LINK}/member/info`);
          }
        }));

        return
      }

    } else {
      setAlertSetting(prev => ({
        ...prev,
        alertTxt: "다시 시도해주세요.",
        btnTxt: '닫기'
      }))
    }
  }

  useEffect(() => {
    const getData = async () => {
      try {
        const response = await touchAPI('GET', URLS.GET_LIST);
        const resData = await response.json();
        if (resData.item_list) {
          setProductList(resData.item_list);
        }
      } catch (error) {
        setAlertSetting(prev => ({
          ...prev,
          alertTxt: `서버 오류입니다.\n관리자에게 문의 바랍니다.`,
          btnTxt: '닫기'
        }));
      }
    };

    getData();
  }, []);

  useEffect(() => {
    if (!isAgree) {
      setSelectedItem({
        item_id: null,
        name: null,
        price: 0,
        discount_price: 0,
        discount_ratio: 0,
      })
    }
  }, [isAgree])

  return (
    <div className="ctn-wrp flx-box st-wrp product-list">
      <div
        className="product-list__title setting-title"
        style={{ padding: 0 }}
      >
        <p className="product-title">{TITLE}</p>
      </div>
      <div className="product-list__wrapper top">
        {
          BENEFITS?.reduce((rows, item, idx) => {
            if (idx % 2 === 0) {
              rows.push([item]);
            } else {
              rows[rows.length - 1].push(item);
            }
            return rows;
          }, []).map((row, rowIndex) => {
            return (
              <div className="product-row flx-box" key={row}>
                {row.map((item, itemIndex) => (
                  <div
                    className={`product-item flx-box ${selectedItem.name === item.NAME ? 'selected' : ''}`}
                    key={item.NAME}
                    style={
                      { borderColor: COLORS[(rowIndex * 2 + itemIndex) % COLORS.length] }}
                  >
                    <p className="item-name">{item.NAME}</p>
                    <p className="item-detail">{item.DETAIL}</p>
                  </div>
                ))}
              </div>
            )
          })
        }
      </div>

      <div className='product-details product-list__wrapper middle'>
        <div className="inner">
          {/* <div className="flx-box agreement">
            <label className="custom-checkbox crs-btn">
              <input
                type="checkbox"
                checked={isAgree}
                onChange={(e) => setIsAgree(e.target.checked)}
              />
              <span className="checkmark"></span>
            </label>
            <p>상품의 가격, 기간 및 환불규정을 확인하였으며 동의합니다.</p>
          </div> */}
          {/* <div className="flx-box"> */}
          <div className="">
            {/* {
              productList?.map((proItem, proIdx) => {
                return (
                  <div className='content' key={proItem.name} >
                    <div className="title">{proItem.name ? proItem.name : '상품명'}</div>
                    <div className="price"
                    ><p className="origin-price">{proItem?.discount_price ? formatToKoreanWon(proItem.price) + '원' : ''}</p>
                      <div className="flx-box">
                        <p className="discount-rate">
                          {proItem?.discount_price > 0 ? (
                            `${((proItem.price - proItem.discount_price) / proItem.price * 100).toFixed(0)}%`
                          ) : null}
                        </p>
                        <p className="final-price">{proItem?.discount_price ? formatToKoreanWon(proItem.discount_price) : formatToKoreanWon(proItem.price)}원</p></div>
                    </div>
                    <div className="action"><button className={`action crs-btn ${isAgree ? 'active' : 'inactive'}`} onClick={(e) => !fetching && handlePurchase(e, proItem)}>바로구매</button></div>
                  </div>
                )
              })
            } */}
            {
              (() => {
                const pairedProducts = [];
                for (let i = 0; i < productList.length; i += 2) {
                  const firstProduct = productList[i];
                  const secondProduct = productList[i + 1];

                  pairedProducts.push(
                    <div className="content-pair flx-box" key={i}>
                      <div className="content" key={firstProduct.name}>
                        <div className="title">{firstProduct.name || '상품명'}</div>
                        <div className="price">
                          <p className="origin-price">{firstProduct?.discount_price ? formatToKoreanWon(firstProduct.price) + '원' : ''}</p>
                          <div className="flx-box">
                            <p className="discount-rate">
                              {firstProduct?.discount_ratio ? (
                                `${(firstProduct.discount_ratio * 100).toFixed(0)}%`
                              ) : null}
                            </p>
                            <p className="final-price">
                              {firstProduct?.discount_price ? formatToKoreanWon(firstProduct.discount_price) : formatToKoreanWon(firstProduct.price)}원
                            </p>
                          </div>
                        </div>
                        <div className="action">
                          <button className={`action crs-btn active`} onClick={(e) => !fetching && handlePurchase(e, firstProduct)}>상품 상세보기</button>
                        </div>
                      </div>

                      {/* 두 번째 product가 있을 때만 렌더링 */}
                      {secondProduct && (
                        <div className="content" key={secondProduct.name}>
                          <div className="title">{secondProduct.name || '상품명'}</div>
                          <div className="price">
                            <p className="origin-price">{secondProduct?.price ? formatToKoreanWon(secondProduct.price) + '원' : ''}</p>
                            <div className="flx-box">
                              <p className="discount-rate">
                                {secondProduct?.discount_ratio ? (
                                  `${(secondProduct.discount_ratio * 100).toFixed(0)}%`
                                ) : null}
                              </p>
                              <p className="final-price">
                                {secondProduct?.discount_price ? formatToKoreanWon(secondProduct.discount_price) : formatToKoreanWon(secondProduct.price)}원
                              </p>
                            </div>
                          </div>
                          <div className="action">
                            <button className={`action crs-btn active`} onClick={(e) => !fetching && handlePurchase(e, secondProduct)}>상품 상세보기</button>
                          </div>
                        </div>
                      )}
                    </div>
                  );
                }
                return pairedProducts;
              })()
            }
          </div>
        </div>
      </div>

      <div className="product-list__wrapper bottom">
        <p className="title">환불규정 안내</p>
        <p className="description">[d라이브러리 패스 (Basic/All) 환불규정]</p>
        <table className="refund-info">
          <tbody>
            <tr>
              <td className="refund-kind">구매를 하였으나 이용하지 않은 경우</td>
              <td className="refund-detail"><div>결제일로부터 7일 이내</div><div>결제일로부터 7일 이후</div></td>
              <td className="refund-detail">
                {
                  isMobile ?
                    <div>전액 환불</div>
                    :
                    `전액 환불`
                }
              </td>
            </tr>
            <tr>
              <td className="refund-kind">이용 이력이 있는 경우</td>
              <td className="refund-detail"><div>1개월 d라이브러리 패스 (Basic/All)</div><div>1개월 초과하는 d라이브러리 패스 (Basic/All)</div></td>
              <td className="refund-detail"><div>환불 불가</div><div>결제대금에서 해지신청일을 포함하는 이용기간(월)에 비례하는 이용대금을 공제한 잔액의 90% 환불<span>예) 6개월 d라이브러리 Basic 패스 구매 후 마지막 사용일이 결제일 기준 40일 경과한 경우, 2개월*5,900원을 공제한 잔액의 90% 환불</span></div></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div >
  )
}
export default Test;
